import { noop } from './noop'

/** Reurns cached value created by lazy initializer with possibility to discard it */
export function onceDiscard<T>(fn: (discard: () => void) => Promise<T>) {
  const cache: { set: boolean; value: Promise<T> | null } = { set: false, value: null }
  return () => {
    if (cache.set) return cache.value!
    let discarded = false
    const discard = () => {
      discarded = true
      cache.set = false
      cache.value = null
    }

    const result = fn(discard)
    cache.set = true
    cache.value = result

    result
      .finally(() => {
        if (discarded) {
          cache.set = false
          cache.value = null
        }
      })
      .catch(noop)

    return result
  }
}
